const Footer = () => {
    return (
        <footer
            className="w-full border-t border-slate-200 dark:border-slate-800
                       bg-slate-200/60 dark:bg-slate-900/60 backdrop-blur-sm
                       transition-colors duration-300"
        >
            <div
                className="container mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6
                           flex flex-col sm:flex-row items-center sm:justify-between gap-3 sm:gap-4
                           text-center sm:text-left"
            >
                <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-400">
                    Copyright &copy; 2026 <span className="font-semibold text-slate-900 dark:text-white">Forge Ultra</span> powered by Ki-Wealth.com
                    <span className="mx-2 text-slate-400 dark:text-slate-600">|</span>
                    All rights reserved
                </p>

                <a
                    href="https://www.ki-wealth.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Ki-Wealth.com (opens in a new tab)"
                    className="group inline-flex items-center gap-2 text-sm font-semibold
                               text-slate-700 dark:text-slate-200
                               hover:text-green-600 dark:hover:text-green-400
                               transition-colors"
                >
                    <span>Back to Ki-Wealth.com</span>
                    <i
                        className="bx bx-right-arrow-alt text-xl
                                   transition-transform group-hover:translate-x-1"
                        aria-hidden="true"
                    ></i>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
